import React, { lazy, useEffect } from "react";
import { ToastProvider } from "react-toast-notifications";
import { useDispatch, useSelector } from "react-redux";
import { useRoutes } from "react-router-dom";
import { useNavigate } from "react-router";
import { Loadable, ModalWrapper, Notification, OverlayWrapper, Toast } from "@shared/components";
import { ENV, NamesOfParentRoutes, TEST_ENV } from "@shared/constants";
import { AuthGuard, GuestGuard } from "@shared/guards";
import { actions, selectors } from "@shared/store";
import { Helmet } from "react-helmet";

import configElement from "../../config";

const AuthContainer = Loadable(
  lazy(() => import("../Auth/containers/AuthContainer/AuthContainer")),
  false,
);

const ApplicatonContainer = Loadable(
  lazy(() => import("../App/ApplicatonContainer")),
  false,
);

const routes = [
  {
    path: `${NamesOfParentRoutes.AUTH}/*`,
    element: (
      <GuestGuard>
        <AuthContainer />
      </GuestGuard>
    ),
  },
  {
    path: `/*`,
    element: (
      <AuthGuard>
        <ApplicatonContainer />
      </AuthGuard>
    ),
  },
];

const App = () => {
  const content = useRoutes(routes);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const notification = useSelector(selectors.getNotification());
  const navigateURL = useSelector(selectors.getNavigateURL());

  useEffect(() => {
    if (navigateURL) {
      navigate(navigateURL);
      dispatch(actions.navigate(""));
    }
  }, [navigateURL, dispatch, navigate]);

  return (
    <>
      {TEST_ENV.includes(configElement.env as ENV) ? (
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
      ) : null}
      <ToastProvider components={{ Toast: Toast }}>
        <Notification notification={notification} />
        <ModalWrapper />
        <OverlayWrapper />
        <div className="App">{content}</div>
      </ToastProvider>
    </>
  );
};

export default App;
